module.exports = __webpack_public_path__ + "img/h_4.4416bafb.png";